export default "__VITE_ASSET__CCga209I__"